export default __webpack_public_path__ + "static/media/start-up.258bc433.svg";